import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { errorRed, tintRed } from "../../design-system/colors";
import MoovsBanner from "../globals/MoovsBanner";

function RemovedInvoiceBanner() {
  return (
    <MoovsBanner
      bannerText="This invoice is no longer available and cannot be paid. Please contact the operator for an updated invoice."
      bannerBgColor={tintRed}
      bannerTextColor={errorRed}
      bannerIcon={<ErrorOutlineIcon style={{ color: errorRed }} />}
    />
  );
}

export default RemovedInvoiceBanner;
